import "./Footer.css";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useLocalizedPath from "../../i18n/useLocalizedPath";

import locateLogo from "../../assets/images/Locate logo white.webp";

import socialIconLinkedIn from "../../assets/images/social-handles/socialLinkedIn.webp";
import socialIconFacebook from "../../assets/images/social-handles/socialFacebook.webp";
import socialIconX from "../../assets/images/social-handles/socialX.webp";

const SOCIAL_LINKS = [
  {
    href: "https://www.linkedin.com/company/locateit-ltd/",
    icon: socialIconLinkedIn,
    label: "LinkedIn",
  },
  {
    href: "https://www.facebook.com/LocateitLimited/",
    icon: socialIconFacebook,
    label: "Facebook",
  },
  { href: "https://x.com/LocateIT_KE", icon: socialIconX, label: "X" },
];

export default function Footer() {
  const { t } = useTranslation();
  const lp = useLocalizedPath();

  return (
    <footer className="footer-container global-padding-5per-left-right">
      <div className="footer-inner">
        <NavLink to={lp("/")} className="footer-logo-container">
          <img loading="lazy" decoding="async" src={locateLogo} alt={t("logoAlt")} className="footer-logo" />
        </NavLink>

        <nav className="footer-links" aria-label={t("menu.label")}>
          <div className="footer-navbar">
            <NavLink to={lp("/")} end className="footer-site-link">
              {t("nav.home")}
            </NavLink>
            <NavLink to={lp("/about")} className="footer-site-link">
              {t("nav.about")}
            </NavLink>
            <NavLink to={lp("/portfolio")} className="footer-site-link">
              {t("nav.portfolio")}
            </NavLink>
            <NavLink to={lp("/resource-centre")} className="footer-site-link">
              {t("nav.resources")}
            </NavLink>
            <NavLink to={lp("/contacts")} className="footer-site-link">
              {t("nav.contact")}
            </NavLink>
          </div>
        </nav>

        <div className="footer-privacy">
          <div>{t("footer.rights", { year: new Date().getFullYear() })}</div>
          <div className="footer-legal-links">
            <NavLink to={lp("/privacy-policy")} className="footer-site-link">
              {t("footer.privacy")}
            </NavLink>
            <span>{t("footer.terms")}</span>
          </div>
        </div>

        <div className="footer-social-handles">
          {SOCIAL_LINKS.map(({ href, icon, label }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
            >
              <img loading="lazy" decoding="async" src={icon} alt={label} className="footer-social-handles-logo" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
